import React from 'react';
import { Icon, Tooltip, useElement } from '@pega/cosmos-react-core';

interface TooltipProps {
  info: string;
  tooltipStyle?: any;
  iconName?: string;
}

const CustomTooltip: React.FC<TooltipProps> = ({ info, tooltipStyle = {}, iconName = 'information' }) => {
  const [showTooltipEl, setShowTooltipEl] = useElement();

  return (
    <>
      <Icon name={iconName} ref={setShowTooltipEl} style={{ ...tooltipStyle }} />
      {showTooltipEl && <Tooltip target={showTooltipEl}>{info}</Tooltip>}
    </>
  );
};

export default CustomTooltip;
